import { Label } from '@fluentui/react/lib/Label';
import { Field } from 'react-final-form';
import Text from 'src/components/text/Text';
import { composeValidators, inputTextFieldComponent } from './ProfileV2SharedComponents';
import { TooltipHost } from '@fluentui/react';
import { IconCallout } from './IconCallout';

export interface IProfileTextInputProps {
  id: string;
  localeCategoryId: string;
  localeLabelId: string;
  localeErrorCategoryId?: string;
  maxLength?: number;
  required: boolean;
  autoFocus?: boolean;
  validators?: Function[];
  hasServerValidationError?: boolean;
  placeholder?: string;
  labelText?: string;
  tooltipContent?: string | JSX.Element | JSX.Element[] | undefined;
  iconName?: string;
}

const TextInputV2 = (props: IProfileTextInputProps): JSX.Element => {
  const {
    id,
    localeCategoryId,
    localeLabelId,
    localeErrorCategoryId,
    required,
    autoFocus,
    hasServerValidationError,
    validators,
    placeholder,
    maxLength = 200,
    labelText,
    tooltipContent,
    iconName
  } = props;

  return (
    <div>
      <div className="field" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          {((localeCategoryId && localeLabelId) || labelText) && (
            <Label tabIndex={-1} htmlFor={id} style={{ marginRight: 8 }}>
              {required ? '* ' : ''}
              {labelText ? labelText : <Text category={localeCategoryId} id={localeLabelId} />}
            </Label>
          )}
        </div>
        {tooltipContent && iconName && (
          <div style={{ marginLeft: 8 }}>
            <TooltipHost>
              <IconCallout iconName={iconName} content={tooltipContent} />
            </TooltipHost>
          </div>
        )}
      </div>
      <div>
        <Field
          id={id}
          name={id}
          required={required}
          component={inputTextFieldComponent}
          validate={composeValidators(validators)}
          maxLength={maxLength}
          autoFocus={autoFocus}
          hasServerValidationError={hasServerValidationError}
          placeholder={placeholder}
          props={{
            localeErrorCategoryId: localeErrorCategoryId
          }}
        />
      </div>
    </div>
  );
};

export default TextInputV2;
